import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetch2, fetch3, fetch4, httpAdmin } from "../../Apis/commonApis";
//security_question / approval_email / false

export let getSettingListItems;

const initialState = {
  loading: false,
  getSettingListCount: 0,
  settingData: null,
};

export const getSettingList = createAsyncThunk(
  "getSettingList",
  async (careHomeId) => {
    const result = await httpAdmin(
      `getSetting?careHomeId=${careHomeId}`,
      "get",
      null
    );
    getSettingListItems = result.data;
    return result;
  }
);

const adminPanelSetting = createSlice({
  name: "adminPanelSetting",
  initialState,
  reducers: {
    getOwnerId(state = initialState, action) {},
  },
  extraReducers: {
    [getSettingList.fulfilled]: (state, { payload }) => {
      // console.log("getsettings:", state, message, error);
      if (payload.data) {
        state.settingData = payload.data;
        state.getSettingListCount += 1;
      }
      state.loading = false;
    },
  },
});

export const { getOwnerId } = adminPanelSetting.actions;
export default adminPanelSetting.reducer;
